import { createContext } from "react";
const FooterContext = createContext({});
export default FooterContext;
